<div *ngIf="index">
  <header routerLink="/rulebook/article/{{ index.id }}">
    <div class="book__header__inner">
      <h2>{{ index.kicker }}</h2>
      <div>{{ index.title }}</div>
    </div>
  </header>

  <div class="index__block index__documents" *ngIf="index.files.length > 0">
    <h3>{{'Documents' | transloco}}</h3>
    <ul>
      <li *ngIf="index.currentFile && index.currentFile.full"><a href="{{ index.currentFile.full }}" target="_blank">{{
          index.currentFile.title }}</a></li>
      <li *ngIf="index.currentFile && index.currentFile.diff"><a href="{{ index.currentFile.diff }}" target="_blank">{{
          index.currentFile.titleDiff }}</a></li>
    </ul>
  </div>

  <div class="index__block index__chapters" *ngIf="index.chapters.length > 0">
    <h3>{{'Chapters' | transloco}}</h3>
    <ul>
      <li *ngFor="let item of index.chapters">
        <a [queryParams]="isIonicApp ? {book: item.kicker, book_title:item.title}: {}" [routerLink]="isIonicApp === true ? '/tabs/tab2/article/'+item.id : '/rulebook/article/'+ item.id" [ngClass]="{'is-active': item.id == parentId}">
          {{ item.kicker }} - {{ item.title }}
        </a>
      </li>
    </ul>
  </div>

  <div class="index__block index__appendixes" *ngIf="index.appendixes.length > 0">
    <h3>{{'Appendixes' | transloco}}</h3>
    <ul>
      <li *ngFor="let item of index.appendixes">
        <a [queryParams]="isIonicApp ? {book: item.kicker, book_title:item.title}: {}" [routerLink]="isIonicApp === true ? '/tabs/tab2/article/'+item.id : '/rulebook/article/'+ item.id"  [ngClass]="{'is-active': item.id == id}">
          {{ item.kicker }} - {{ item.title }}
        </a>
      </li>
    </ul>
  </div>
</div>
